import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import { DateDisplayDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

/**
 * Date/time cell that reveals the full value on hover when the column is too narrow to show it,
 * matching how the shared `text` column already behaves.
 *
 * AG Grid's own `tooltipShowMode="whenTruncated"` can't do this: `enableCellTooltipFeature` only
 * installs its overflow check when the column has no `cellRenderer`, and this column has one.
 * Opting in would show a tooltip on every date, truncated or not. TextTruncate measures the
 * rendered element instead (scrollWidth vs clientWidth), so the popover appears only when the date
 * is actually clipped.
 */
function columnDateTimeInternal(props: IGridCellRendererParams) {
    const value = props.value as string | number | Date | null | undefined;
    if (props.node.group || value == null) {
        return null;
    }
    return (
        <TextTruncate>
            <DateDisplayDate
                data-testid="ag-col-date-time"
                value={value instanceof Date ? value : new Date(value)}
                showTime
                className={cn("ag-col-date-time", props.className)}
            />
        </TextTruncate>
    );
}

export const columnDateTime = memo(columnDateTimeInternal);
